<template>
  <svg
    :class="customStyle"
    viewBox="0 0 8 12"
    fill="#128c8c"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.42847 10.982L7.42847 9.97754C7.42847 9.90923 7.39498 9.84494 7.34007 9.80477L2.09543 5.99986L7.34007 2.19494C7.39498 2.15477 7.42847 2.09048 7.42847 2.02218L7.42847 1.01771C7.42847 0.930659 7.32936 0.879766 7.25838 0.930659L0.748108 5.65298C0.512394 5.82441 0.512394 6.1753 0.748108 6.34539L7.25838 11.0677C7.32936 11.1199 7.42847 11.0691 7.42847 10.982Z"
      fill="#128C8C"
    />
  </svg>
</template>

<script>
export default {
  name: 'ArrowVector',

  props: {
    customStyle: {
      type: String,
      default: 'w-4 h-4',
    },
  },
}
</script>
